export const ROUTER_CONFIG = {
  notFound: '404',
  forbidden: '403',
  auth: {
    login: 'login',
  },
  pdfPreviewVersion: 'pdf-preview/version',
  notifications: 'notifications',
  businessManagement: 'business-management',
  ccjAdmin: 'admin-role/ccj-admin',
  roleManagement: 'admin-role/role-management',
  roleManagementCreate: 'admin-role/role-management/create',
  roleManagementEdit: 'admin-role/role-management/edit',
  roleManagementDelete: 'admin-role/role-management/delete',
  roleManagementUpdateUserRole: 'admin-role/ccj-admin/update',
};
